import { Component, HostBinding, Input } from '@angular/core';


@Component({
    selector: 'app-material',
    templateUrl: './material.component.html',
    styleUrls: ['./material.component.scss']
})
export class MaterialComponent {

    @Input() isLoading = false;
    @Input() @HostBinding('class.material') material = true;

    constructor() {

    }
}
